<div class="tab-content" id="OemPortalTabs">
    <!-- Tab 1 - Enter Model SKU Info -->
    <div class="tab-pane fade show active" id="enterModelInfoTab">
      <div id="oemPortalTabsContent" class="d-flex flex-column h-100">
        <!-- Data heading and info -->
        <div id="oemPortalTabsDataHeader" class="data_header">
          <div id="oemPortalLeftSection" class="left_side_section">
            <div id="oemPortalData" class="results_info">
              <div id="oemPortalTitle" class="title"><span i18n ="@@attractor-loop.title.attract-loop">Attract Loop</span></div>
              <div id="oemPortalResults" class="results"><span i18n ="@@attractor-loop.pagination.attract-loop">Showing <strong> {{showFrom}} - {{showTo}} </strong>of
                  <strong>{{attractorLoop?.length}} Attract Loop Videos</strong></span>
              </div>
            </div>
            <div id="searchGroupInput" class="search_group" *ngIf="hasData">
              <div id="inputGroup" class="input-group">
                <input type="text" id="attractLoopSearch" class="form-control input" #searchValue [(ngModel)]="searchData"
                  placeholder="{{searchPlaceholder}}" (ngModelChange)="clearSearch(searchData)" (keyup.enter)="searchDataOnEnter(searchData)"/>
                  <img class="search-clear-icon" alt="{{closeAlt}}" *ngIf="searchClose && searchData?.length"
                  (click)="clearSearchDirect()" />
                <div id="oemPortalDropDown" ngbDropdown class="btn-group" id = "toogle">
                  <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle dropdown-content" id="sizeDropDown"
                    aria-haspopup="true" aria-expanded="false">
                      {{ valueForSearchinUsers }}
                  </button>
                <div id="oemPortalDropDownMenu" ngbDropdownMenu aria-labelledby="sizeDropDown">
                  <a ngbDropdownItem selected="selected" *ngIf="valueForSearchinUsers!=name"
                      (click)="onSelectChange('1')"><span i18n = "@@users-retailhq.downloadcsv.name">Name</span></a>
                  <a ngbDropdownItem *ngIf="valueForSearchinUsers!=systemId" (click)="onSelectChange('2')" i18n = "@@review-comment.system-id.system-id">System ID</a>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary search_btn" (click)="searchDataOnClick(searchData)">
              <img class="search_icon" alt="{{searchAlt}}" />
            </button>
          </div>
            <iposcen-spinner-overlay></iposcen-spinner-overlay>
          </div>
          <div id="oemPortalBtn" class="action_buttons" *ngIf="hasData">
            <button type="button" class="btn btn-primary btn-lg left_icon_btn"
              (click)="sendDataForCreateAttract()">
              <!--  -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {{newAttractLoopButton}}
            </button>
          </div>
        </div>
        <hr />
  
        <div id="oemPortalNoData" class="no-record" *ngIf='noDataOnSearch'>
          <span i18n = "@@model-sku-info.screenmsg.norecord">No Records Found</span>
        </div>
        <div id="oemPortalDataAttract" class="empty_screen_msg" *ngIf="!hasData">
          <span>
            <div><span i18n ="@@attractor-loop.screenmsg.no-attract-loop">There is no Attract Loop Video yet</span></div>
          </span>
          <div id="oemPortalEmptyBtn" class="emptyScreen_button">
            <button type="button" class="btn btn-primary btn-lg left_icon_btn addButton"
              (click)="sendDataForCreateAttract()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {{newAttractLoopButton}}
            </button>
          </div>
        </div>
  
        <!-- Table data -->
        <div id="attractLoop" *ngIf="hasData && !noDataOnSearch">
          <div id="attractLoopContent" class="table-responsive">
            <table id="attractLoopTable" aria-describedby="Attract Loop table" class="table table-borderless">
              <thead>
                <tr>
                  <th scope="col">
                    <span class="table_headings" (click)="sort('attractLoopName')">
                      <span i18n ="@@attractor-loop.data-header.name">Name</span> 
                    <span class="chevron_expand"></span>
                  </span>
                  </th>
                  <th scope="col">
                    <span class="table_headings">
                      <span i18n = "@@model-sku-info.table.systemid">System ID</span>
                    </span>
                  </th>
                  <th scope="col">
                    <span class="table_headings">
                      <span i18n = "@@model-sku-info.table.location">Location</span>
                    </span>
                  </th>
                  <th scope="col">
                    <span class="table_headings" (click)="sort('reviewStatus')">
                      <span i18n = "@@model-sku-info.table.status">Status</span>
                      <span class="chevron_expand"></span>
                    </span>
                  </th>
                  <th scope="col">
                    <span class="table_headings" (click)="sort('updatedTime')">
                      <span i18n = "@@model-sku-info.table.lastupdated">Last Updated</span>
                      <span class="chevron_expand"></span>
                    </span>
                  </th>
                  <th scope="col">
                    <span class="table_headings" (click)="sort('updatedByName')">
                      <span i18n = "@@model-sku-info.table.lastupdatedby">Last Updated By</span>
                      <span class="chevron_expand"></span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="hasData && !noDataOnSearch">
                <ng-container *ngFor="let item of attractorLoop | slice: (page-1) * tableSize : page * tableSize">
                  <tr>
                    <td>{{item.attractLoopName}}</td>
                    <td>
                     <span *ngIf= "obj.values(item?.systemIDMap)?.length == 1">{{item ? obj.values(item?.systemIDMap):''}}</span>
                     <span *ngIf = "obj.values(item?.systemIDMap)?.length > 1" [ngbPopover]='popUp' 
                      [popoverTitle]="obj.values(item?.systemIDMap)?.length + ' System IDs'" placement="right">
                       {{obj.values(item?.systemIDMap)[0]}} <span class="popup-badge">+{{obj.values(item?.systemIDMap)?.length - 1}}</span>  
                     </span>
                    </td>
                    <ng-template #popUp>
                      <div id="popupList">
                        <div id="systemIdMap"
                          [ngClass]="{'popup-size-scroll':obj.values(item?.systemIDMap)?.length>5,'popup-size':obj.values(item?.systemIDMap)?.length<=5}">
                          <ul class='reduceLeftPad' *ngFor='let popupList of obj.values(item?.systemIDMap)'>
                            <li class="child">{{popupList}}</li>
                          </ul>
                        </div>
                      </div>
                    </ng-template>
                    <td>
                      <!-- Location Column -->
                      <span *ngIf="item?.parsedLocations?.length == 1">
                        {{item.parsedLocations[0]}}
                      </span>
                      <span *ngIf="item?.parsedLocations?.length > 1 && item?.parsedLocations?.length < 66">
                        {{item.parsedLocations[0]}} 
                        <span class="popup-badge" [ngbPopover]='locationPopUp'
                          [popoverTitle]="item.parsedLocations.length + ' Locations'" placement="right">
                          +{{item.parsedLocations.length - 1}}
                        </span>
                      </span>
                      <span *ngIf="item?.parsedLocations?.length >= 66">
                        All Locations
                      </span>
                    </td>
                    
                    <!-- Location Popup Template -->
                    <ng-template #locationPopUp>
                      <div id="locationPopupList">
                        <div id="locationMap"
                          [ngClass]="{'popup-size-scroll': item.parsedLocations.length > 5, 'popup-size': item.parsedLocations.length <= 5}">
                          <ul class='reduceLeftPad'>
                            <li class="child" *ngFor='let location of item.parsedLocations'>{{location}}</li>
                          </ul>
                        </div>
                      </div>
                    </ng-template>                    
                    
                    <td>
                      <div class="status_column" id="attractLoopstatus">
                        <em *ngIf="item.reviewStatus === 'approved'" class="approved_icon"></em>
                        <em *ngIf="item.reviewStatus === 'submitted' || item.reviewStatus === 'pending'" class="submitted_icon"></em>
                        <em *ngIf="item.reviewStatus === 'returned'" class="returned_icon"></em>
  
                        <span>{{checkCase(item.reviewStatus)}}</span>
                        <img *ngIf="item.reviewStatus === 'approved'" class="info_circle_icon" placement="top"
                          [popoverTitle]="approvepop" [ngbPopover]="approvedTooltipDesc"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                        <img *ngIf="item.reviewStatus === 'submitted' || item.reviewStatus === 'pending'" class="info_circle_icon" placement="top"
                          [popoverTitle]="submitpop" [ngbPopover]="submittedTooltipDesc"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                        <img *ngIf="item.reviewStatus === 'returned'" class="info_circle_icon" placement="top"
                          [popoverTitle]="returnpop" [ngbPopover]="returnedTooltipDesc"
                          container="body" alt="" triggers="mouseenter:mouseleave" />
                      </div>
                    </td>
                    <td>{{item.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                    <td>{{item.updatedByName}}</td>
                    <td class="action_cell">
                      <span class="modify_record">

                        <!-- IIT2-1726 Start -->
                        <div id="attractLoopOpen" *ngIf="item.reviewStatus !== 'submitted'"
                          class="delete_record cell_record" (click)="openDeleteModal(item.attractLoopId, item.attractLoopName)">
                          <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="deleteTooltip" class="delete_icon"
                            alt="delete" />
                        </div>
                        <iposcen-delete-popup #deleteModal [contentName]="attractLoopToDeleteName"
                        [isAttractLoop]="true" (delete)="deleteAttractLoop(attractLoopToDelete)">
                        </iposcen-delete-popup>
                        <!-- IIt2-1726 End -->
                        <div id="attractLoopSend" *ngIf="item.reviewStatus !== 'submitted'" (click)='sendDataForCreateAttract(item)' class="edit_record">
                          <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="editTooltip"
                            class="edit_icon" alt="edit" />
                        </div>
                        <div id="attractLoopOpenView" class="view_record">
                          <button *ngIf="item.reviewStatus !== 'saved'" (click)='openView(item.attractLoopId)'
                            class="btn btn-link btn-teritiary left_icon_btn">
                            <img class="view_icon" alt="view" /><span
                              i18n="@@create-partner-content.table-data.view">View</span>
                          </button>
                        </div>
                        <div id="attractLoopSubmit" class="submit_record">
                          <button *ngIf="item.reviewStatus === 'saved'" (click)='submit(item.attractLoopId)'
                            class="btn btn-link btn-teritiary left_icon_btn">
                            <img class="submit_icon" alt="submit" /><span
                              i18n="@@create-partner-content.table-data.submit">Submit</span>
                          </button>
                        </div>
                      </span>
                    </td>
                  </tr>
                </ng-container>
  
              </tbody>
            </table>
          </div>
        </div>
        <hr *ngIf="hasData && !noDataOnSearch" />
        <ng-template #approvepop>
          <div id="approvedIcon" class="d-flex"><em class="approved_icon mr-2"></em>
            <span i18n = "@@model-sku-info.template.approved">Approved</span>
          </div>
  
        </ng-template>
        <ng-template #submitpop>
          <div id="submittedIcon" class="d-flex"><em class="submitted_icon mr-2"></em>
            <span i18n = "@@model-sku-info.template.submitted">Submitted</span>
          </div>
  
        </ng-template>
        <ng-template #returnpop>
          <div id="returnedIcon" class="d-flex"><em class="returned_icon mr-2"></em>
            <span i18n = "@@model-sku-info.template.returned">Returned</span>
          </div>
  
        </ng-template>

        <!-- IIT2-1843 Start -->
        <div id="oemPortalContainer" class="container" *ngIf="isSubmit">
          <div id="oemPortalBackdrop" class="modal-backdrop show"></div>
          <!-- The Modal -->
          <div class="modal" id="successAuthorModal">
            <div id="successAuthorModalDialog" class="modal-dialog modal-lg">
              <div id="successAuthorModalContent" class="modal-content">
                <div id="invitePopupCard" class="card invitePopup">
                  <div id="inviteModalHeader" class="modal-header">
                    <div id="inviteModalClose" class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSubmitSuccessPopup()">
                    </div>
                  </div>
                  <!-- Modal body -->
                  <div id="inviteModalBody" class="modal-body invitesuccess-panel">
                    <div Id="inviteImg" class="invitesuccess_img_div text-center">
                      <span class="invitesuccess_img"></span>
                    </div>
                    <div id="inviteTitle" class="invitesuccess-title text-center">
                      <span i18n ="@@create-partner-content.template.submitted-for-approval">Submitted for Approval</span>
                    </div>
                    <div id="inviteContent" class="invitesuccess-content text-center"><span i18n ="@@create-partner-content.template.review-content" >An Intel Admin will review your Content
                        shortly.</span></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Popup Modal ends Here -->
          </div>
        </div>
        <!-- IIT2-1843 End -->
  
  
        <!-- Pagination -->
        <div id="invitePagination" class="data_footer position-relative" *ngIf="hasData && !noDataOnSearch">
          <div id="inviteContent" class="d-flex flex-column align-items-center">
            <nav aria-label="Model SKUs pagination">
              <ngb-pagination [collectionSize]="attractorLoop?.length" [(page)]="page" [pageSize]="tableSize"
                [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                (pageChange)="onTableDataChange($event)">
              </ngb-pagination>
            </nav>
            <div id="inviteResults" class="results mt-2"><span i18n ="@@attractor-loop.pagination.attract-loop">Showing <strong> {{showFrom}} - {{showTo}} </strong>of
              <strong>{{attractorLoop?.length}} Attract Loop Videos</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
